// Quyền lợi theo cấp clan: mỗi cấp trên cấp 1 thêm 5 chỗ thành viên; cấp 3 đến 4 giảm 5% gói Trợ lý AI, cấp 5 giảm 10%.
export const MAX_CLAN_LEVEL = 5;

export const clanLevelPerks = (level: number): string[] => {
  const perks: string[] = [];
  if (level > 1) perks.push(`Thêm ${(level - 1) * 5} chỗ thành viên`);
  if (level >= 5) perks.push('Giảm 10% gói Trợ lý AI');
  else if (level >= 3) perks.push('Giảm 5% gói Trợ lý AI');
  return perks;
};
